/* eslint-disable */
(function() {
    angular
        .module('MktzapApp.Controllers')
        .requires
        .push(
            'ngTable'
        );

    angular.module('MktzapApp.Controllers')
        .controller('ReportTeleSaqueB2BTransactionController', reports);

    reports.$inject = ['$scope', '$http', 'LangService', 'NotificationService', 'ReportTeleSaqueB2BTransactionService', 'ngTableParams'];

    function reports($scope, $http, LangService, NotificationService, ReportTeleSaqueB2BTransactionService, ngTableParams) {

        var vm = this;
        $scope.vm = vm;
        $scope.transactions = [];

        LangService
            .getPageLabels({ 'page': 'menu.reports.telesaqueb2b_transactions' })
            .$promise
            .then(function(data) {
                vm.labels = data.lang;
            });


        vm.filters = {
            fromDate: moment().startOf("month").format("DD/MM/YYYY"),
            toDate: moment().endOf("month").format("DD/MM/YYYY"),
            exportMedalia: false,
        };

        vm.dateSelected = function(type, date) {
            if (type == 'from') {
                vm.pkadayToDate.setMinDate(date);
            }
            if (type == 'to') {
                vm.pkadayFromDate.setMaxDate(date);
            }
        };

        function validateFields() {
            var toDate = moment(vm.filters.toDate, 'DD/MM/YYYY')
            var fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY')
            if (toDate < fromDate) {
                NotificationService.warningHandler('', 'Data inicial Invalida')
                vm.show = false
                return false
            }
            if (toDate.diff(fromDate, 'days') > 30) {
                vm.show = false
                NotificationService.warningHandler('', 'Periodo maximo de busca de 30 dias')
                return false
            }
            return true
        }

        vm.clearSearch = function() {
            vm.filters.phone = ''
            vm.filters.cpf = ''
            vm.filters.generate_token_intention = ''
            vm.filters.generate_link_intention = ''
            vm.filters.return_stoneage_intention = ''
            vm.filters.withdraw_confirmation_intention = ''
            vm.tableAround = ''
        }

        vm.getTransactions = function() {
            vm.tableAround = false;
            console.log(vm.filters)
            vm.transactionsTable = new ngTableParams({
                page: 1, // show first page
                count: 30, // count per page
            }, {
                counts: [25, 50, 100],
                getData: function($defer, params) {
                    var obj = params.url();
                    obj = {
                        page: obj['page'],
                        count: obj['count'],
                        filters: vm.filters
                    }

                    ReportTeleSaqueB2BTransactionService
                        .paged(obj)
                        .$promise
                        .then(function(retorno) {
                            console.log(retorno.result.data)

                            if (retorno.success === false) {
                                NotificationService.warningHandler(retorno, retorno.message)
                                return;
                            }

                            params.total(retorno.result.total)
                            $defer.resolve(retorno.result.data)
                            vm.data_total = retorno.result.total
                            vm.data_result = retorno.result.data.length
                            vm.tableAround = true
                        }).catch(function({ data }) {
                            const errors = data.errors.validation
                            if (errors) {
                                errors.map(function(message) {
                                    NotificationService.warningHandler(null, message)
                                })
                            } else {
                                NotificationService.errorHandler(null, data.errors)
                            }

                        })
                }
            })

        }

        vm.statusValidation = function(status) {
            switch (status) {
                case 'APROVED':
                    color = '#65a949'
                    break;
                case 'REPROVED':
                case 'MAX_TRIES':
                case 'CLIENT_NOT_SUPPORTED':
                case 'NO_DATA_PERMISSION':
                case 'ABANDONED':
                case 'EXPIRED':
                    color = '#ff5959'
                    break;
                case null:
                    color = '#fae20d'

            }

            console.log(color)

            return color
        }


        vm.downloadTransactions = function() {
            vm.filters.exportMedalia = true;
            vm.filters.isSearch = false;

            $http.get(apiUrl + '/reports/telesaqueb2b-transactions-download', {
                    params: {
                        filters: vm.filters
                    }
                })
                .then(function(retorno) {
                    const filedata = retorno.data;

                    const success = prepareFileForDownload(filedata)

                    if (!success) {
                        NotificationService.warningHandler(data, $scope.labels.noRecord)
                    }
                }).catch(function({ data }) {

                    const errors = data.errors.validation
                    if (errors) {
                        errors.map(function(message) {
                            NotificationService.warningHandler(null, message)
                        })
                    } else {
                        NotificationService.errorHandler(null, data.errors)
                    }

                })
        }

        function prepareFileForDownload(data) {
            let component = angular.element('<a/>')
            component.css({ display: 'none' })
            angular.element(document.body).append(component)

            let blob = new Blob([data], { type: 'text/csv' })

            if (blob.size <= 58) {
                return false
            }

            let csvUrl = URL.createObjectURL(blob)

            component.attr({
                href: csvUrl,
                target: '_self',
                download: 'TelesaqueB2B_Transactions.csv'
            })[0].click()

            component.remove()
            URL.revokeObjectURL(csvUrl)

            return true
        }
    }
})();